var n=function(){return"undefined"!=typeof window};export{n as i};
//# sourceMappingURL=isBrowser-3756bbdd.js.map
